
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/qdrant",
      function () {
        return require("private-next-pages/customers/qdrant.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/qdrant"])
      });
    }
  